const createMallTemplate = async ({ params, api }) => {
  return await api('mallTemplate', { body: params.data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default createMallTemplate;